// @ts-expect-error untyped
import PropertyGroupRecord from 'customer-data-objects/property/PropertyGroupRecord';
export const isPropertyGroupRecord = record => {
  return record instanceof PropertyGroupRecord;
};